import { createClient } from '@sanity/client'

const client = createClient({
  projectId: 'og5biutf',
  dataset: 'production',
  useCdn: true,
  apiVersion: '2025-11-16'
});

export default client;
